import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export const CTASection = () => {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-2063" data-mp="31sgprz0ps6j8">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2064" data-mp="2o0a8uapqlviq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-[#0a0a0a] rounded-3xl p-10 md:p-20 text-center shadow-2xl relative overflow-hidden border border-gray-800" data-id="element-2065" data-mp="2nxeawmdw36ua">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay" data-id="element-2066" data-mp="3bqwg3zrx3bro" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF0000]/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-2067" data-mp="20a6g4ye37g6i" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FFD700]/5 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-2068" data-mp="172uk8ze8yhvv" />

          {/* Grid Overlay */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-2069" data-mp="1h08uuidhocg9" />

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-2070" data-mp="1px9kescaogla">
            <div className="inline-flex items-center gap-2 mb-8 bg-[#FF0000]/10 border border-[#FF0000]/30 px-4 py-1.5 rounded-full" data-id="element-2071" data-mp="1lxivku6bwaje">
              <ShieldCheck size={16} className="text-[#FF0000]" data-id="element-2072" data-mp="1zr9tf5ap65za" />
              <span className="text-[#FF0000] font-mono text-xs tracking-widest uppercase font-bold" data-id="element-2073" data-mp="1uqvxumqa8oi5">
                Secure & Confidential
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-black text-white mb-8 tracking-tight leading-[1.1] uppercase" data-id="element-2074" data-mp="24pl57lkjyqk5">
              Ready to Protect <br data-id="element-2075" data-mp="2btjghddxcqf3" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-2076" data-mp="2bpvr8qfiiq66">
                Your Peace?
              </span>
            </h2>

            <p className="text-gray-400 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed font-mono" data-id="element-2077" data-mp="2lobe2h7ibd9v">
              Join thousands who've discovered toxic patterns in their
              relationships. Start with a free forensic scan today.
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center max-w-md mx-auto" data-id="element-2078" data-mp="2zgjag7uvp281">
              <a href="/signup" className="group flex-1 bg-[#FF0000] text-white rounded-xl py-4 px-8 font-bold uppercase tracking-wider hover:bg-red-600 transition-all shadow-[0_0_20px_rgba(255,0,0,0.3)] hover:shadow-[0_0_30px_rgba(255,0,0,0.5)] flex items-center justify-center gap-2 hover:-translate-y-1" data-id="element-2079" data-mp="34g490h64z8k8">
                <span data-id="element-2080" data-mp="1f3ako3445yui">Start Free Scan</span>
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-2081" data-mp="17i6n8mp1hrx5" />
              </a>

              <button onClick={() => {
              const element = document.getElementById('pricing');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }} className="flex-1 bg-transparent border border-gray-700 text-white rounded-xl py-4 px-8 font-bold uppercase tracking-wider hover:border-white hover:bg-white/5 transition-all flex items-center justify-center hover:-translate-y-1" data-id="element-2082" data-mp="xs50pzcc4hkc">
                View Pricing
              </button>
            </div>

            <p className="mt-8 text-xs text-gray-500 font-mono uppercase tracking-widest" data-id="element-2083" data-mp="51d6v8iqs506">
              No Credit Card Required for Trial
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};